/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { CaseManagementUserDto } from './case-management-user-dto';
import { ClearanceCaseStatus } from '../enums/clearance-case-status.enum';
import { ClearanceCaseCustomerStatus } from '../enums/clearance-case-customer-status.enum';
import { CpcDocumentMessageType } from '../enums/cpc-document-message-type.enum';
import { ExportLogEntryDto } from './export-log-entry-dto';
import { ClearanceCaseLogMessageType } from '../enums/clearance-case-log-message-type.enum';

//<custom-head>
import {
  parseDate,
  CssUtils,
  formattedDate,
  translateMessageType
} from 'app/utils';
import { Translations } from 'app/translations';
import { ExportLogStatusChangeDto } from './export-log-status-change-dto';
//</custom-head>

export class ClearanceCaseLogDto {
  public id: string = undefined;
  public dateTimeUtc: Date | string;
  public handler: CaseManagementUserDto;
  public status: ClearanceCaseStatus;
  public previousCaseStatus: ClearanceCaseStatus;
  public customerStatus: ClearanceCaseCustomerStatus;
  public description: string = undefined;
  public errorMessages: string[];
  public internal: boolean;
  public messageType: CpcDocumentMessageType;
  public messageTypeText: Object;
  public exportReference: string = undefined;
  public clearanceCaseVersion: number = undefined;
  public exportLogEntry: ExportLogEntryDto;
  public logMessageType: ClearanceCaseLogMessageType;

  //<custom-body>
  constructor(source: ClearanceCaseLogDto) {
    Object.assign(this, source);

    this.dateTimeUtc = parseDate(source.dateTimeUtc);
    this.handler = source.handler;
  }

  public static GetLogLabelClass(status: ClearanceCaseStatus): string {
    return CssUtils.caseLogLabelClass(status);
  }

  public static GetCustomerLogLabelClass(
    status: ClearanceCaseCustomerStatus
  ): string {
    return CssUtils.customerCaseLogLabelClass(status);
  }

  public get isSystem(): boolean {
    if (!this.handler) return true;
    return this.handler.isSystem;
  }

  public get isEcus(): boolean {
    if (!this.handler) return false;
    return this.handler.isEcus;
  }

  public get isClient(): boolean {
    if (!this.handler) return false;
    return this.handler.isClient;
  }

  public get createdBy(): string {
    return this.handler ? this.handler.initials : 'Okänd';
  }

  public get createdByName(): string {
    return this.handler ? this.handler.name : 'Okänd';
  }

  public get formattedDate(): string {
    return formattedDate(parseDate(this.dateTimeUtc));
  }

  public get logLabelClass(): string {
    return ClearanceCaseLogDto.GetLogLabelClass(this.status);
  }

  public get requiresAdminRole(): boolean {
    return (
      this.logMessageType == ClearanceCaseLogMessageType.ForcedStatusChanged
    );
  }

  public get logLabel(): string {
    if (
      this.logMessageType == ClearanceCaseLogMessageType.ForcedStatusChanged
    ) {
      if (this.previousCaseStatus || this.previousCaseStatus != 0) {
        return `${this.translateStatus(
          this.previousCaseStatus
        )} <i class="fa fa-long-arrow-right"></i> ${this.translateStatus(
          this.status
        )}`;
      }
      return this.translateStatus(this.status);
    }

    if (this.logMessageType == ClearanceCaseLogMessageType.Invoiced) {
      return 'Fakturerat';
    }

    if (this.logMessageType == ClearanceCaseLogMessageType.NotInvoiced) {
      return 'Valdes att ej faktureras';
    }

    if (
      this.internal &&
      this.logMessageType !== ClearanceCaseLogMessageType.Normal
    )
      return this.translateLogMessageType(this.logMessageType);

    let prefix = '';
    if (this.exportLogEntry) {
      prefix = `${translateMessageType(this.exportLogEntry.messageType)}: `;
    }

    return `${prefix}${this.translateStatus(this.status)}`;
  }

  public get logReference(): string {
    if (this.exportReference && this.exportReference !== '')
      return `v${this.clearanceCaseVersion} (${this.exportReference})`;

    return `v${this.clearanceCaseVersion}`;
  }

  public get customerLogLabelClass(): string {
    return ClearanceCaseLogDto.GetCustomerLogLabelClass(this.customerStatus);
  }

  public get customerLogLabel(): string {
    return this.translateCustomerStatus(this.customerStatus);
  }

  public get byClient(): boolean {
    return !this.handler.email.endsWith('@ecus.se');
  }

  private translateCustomerStatus(s: ClearanceCaseCustomerStatus): string {
    return Translations.ClearanceCaseCustomerLogEntry[
      ClearanceCaseCustomerStatus[s]
    ];
  }

  private translateStatus(s: ClearanceCaseStatus): string {
    return Translations.ClearanceCaseLogEntry[ClearanceCaseStatus[s]];
  }

  private translateLogMessageType(s: ClearanceCaseLogMessageType): string {
    return Translations.ClearanceCaseLogMessageType[
      ClearanceCaseLogMessageType[s]
    ];
  }

  public get statusChanges(): ExportLogStatusChangeDto[] {
    return [];
  }
  //</custom-body>
}
